import React, { useState } from "react";
import PRODUCTS from "./productData";
import './ProductPage.css';

const sectionNames = [
  
  "Rental-Products",
  "Solar Panel",
  "Inverter(Solar/Hybrid/OnGrid)",
  "Solar Battery",
  "UPS Battery",
  "Solar Water Heater",
  "Street Light",
  "CCTV/Solar Camera",
  "Automotive Battery",
  "Twowheeler Battery",
  "Lithium Battery",
  "DC Solar",
  "Agricultural Products",
  "Lubricants",
  "Structure(GI/MS/Aluminium)",
  "Accessories",  
];

const ProductPage = ({ handleAddToCart }) => {
  const [selectedSection, setSelectedSection] = useState(null);

  const handleSectionClick = (section) => {
    setSelectedSection(section);
  };

  const filteredProducts = selectedSection
    ? PRODUCTS.filter(product => product.sectionName === selectedSection)
    : PRODUCTS;

  return (
    <div>
      {/* Section Buttons */}
      <div className="section-buttons-container">
        <button onClick={() => setSelectedSection(null)} className="section-button reset">
          All Products
        </button>
        {sectionNames.map((section, index) => (
          <button
            key={index}
            className={`section-button ${selectedSection === section ? 'active' : ''}`}
            onClick={() => handleSectionClick(section)}
          >
            {section}
          </button>
        ))}
        
      </div>

      {/* Product Cards */}
      <div className="products1-container">
        {filteredProducts.map((product) => (
          <div key={product.id} className="product-card1">
            <img src={product.image} alt={product.name} />
            <h3>{product.name}</h3>
            <p>₹{product.price}</p>
            <button onClick={() => handleAddToCart(product)}>Add to Cart</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductPage;